module.exports = __webpack_public_path__ + "fonts/Manrope-500-cyrillic8_efc8e8d.woff2";